var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.93 32.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #003e4c;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        fill: #003e4c;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 4.42,
    y: 1.43,
    width: 28.62,
    height: 34.41,
    rx: 4.12,
    ry: 4.12,
    transform: "translate(37.36 -.1) rotate(90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 3.4,
    y: -2.4,
    width: 28.62,
    height: 34.41,
    rx: 4.12,
    ry: 4.12,
    transform: "translate(32.51 -2.9) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m10.89,23.28c-.17,0-.29-.05-.39-.15-.09-.1-.14-.22-.14-.37V7.95c0-.17.05-.3.14-.4.09-.1.22-.15.39-.15h5.76c1.12,0,2.09.18,2.91.54.82.36,1.46.9,1.92,1.62s.68,1.61.68,2.69-.23,1.97-.68,2.68-1.09,1.25-1.92,1.61c-.82.36-1.8.54-2.91.54h-4.01v5.67c0,.15-.05.28-.15.37s-.23.15-.4.15h-1.2Zm1.72-8.1h3.92c1.12,0,1.96-.25,2.52-.75.56-.5.84-1.23.84-2.18s-.27-1.66-.82-2.18-1.39-.77-2.54-.77h-3.92v5.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m28.12,22.77c-.49,0-.9-.09-1.22-.26-.33-.17-.59-.39-.78-.65v.51c0,.08-.03.15-.08.2s-.12.08-.2.08h-.56c-.08,0-.15-.03-.2-.08-.05-.05-.08-.12-.08-.2v-8.11c0-.08.03-.15.08-.2.05-.05.12-.08.2-.08h.59c.09,0,.16.03.21.08.05.05.07.12.07.2v2.81c.2-.25.47-.46.79-.64.32-.17.72-.26,1.19-.26s.84.08,1.17.24c.32.16.59.38.79.65s.36.59.47.94c.11.35.16.72.17,1.1,0,.13.01.25.01.37s0,.24-.01.37c0,.39-.07.76-.17,1.11-.11.35-.26.66-.47.93s-.47.49-.79.65c-.32.16-.71.24-1.17.24Zm-.26-.99c.42,0,.75-.09,1-.27.24-.18.41-.42.52-.72.11-.3.17-.62.18-.96,0-.24,0-.47,0-.71-.02-.34-.08-.66-.18-.96-.11-.3-.28-.54-.52-.72-.24-.18-.57-.27-1-.27-.38,0-.7.09-.95.27s-.44.41-.57.68c-.13.28-.19.56-.2.84,0,.13-.01.29-.01.47s0,.34.01.47c.02.3.08.6.2.89.12.29.3.53.55.71.25.19.57.28.97.28Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPb);
export default __webpack_public_path__ + "static/media/Pb.a41c8a0ae7c6876678088288281376bd.svg";
export { ForwardRef as ReactComponent };